import { render } from "./AlertBox.vue?vue&type=template&id=4741bced&scoped=true"
import script from "./AlertBox.vue?vue&type=script&lang=js"
export * from "./AlertBox.vue?vue&type=script&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=4741bced&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4741bced"]])

export default __exports__